import type { CSSProperties } from "react";
import type { CampaignSectionStyle } from "@growwithai/shared";

/**
 * Kustomisasi visual opsional per-section (khusus halaman promosi — section
 * beranda tenant tidak pernah punya `style`, jadi fungsi ini selalu balik `{}`
 * untuknya, nol perubahan visual).
 *
 * Diterapkan sebagai inline `style` di elemen yang SUDAH ADA (bukan ganti
 * className) — inline style selalu menang atas class Tailwind untuk properti
 * CSS yang sama, jadi aman ditambahkan tanpa menyentuh style default.
 */
export function sectionBgStyle(style?: CampaignSectionStyle): CSSProperties {
  return style?.background_color ? { backgroundColor: style.background_color } : {};
}

const FONT_SIZE_REM: Record<NonNullable<CampaignSectionStyle["font_size"]>, string | undefined> = {
  sm: "1.25rem",
  base: undefined, // 'Normal' → tak override, pakai ukuran bawaan komponen
  lg: "2rem",
  xl: "2.75rem",
};

export function sectionHeadingStyle(style?: CampaignSectionStyle): CSSProperties {
  return {
    ...(style?.text_color ? { color: style.text_color } : {}),
    ...(style?.font_size && FONT_SIZE_REM[style.font_size]
      ? { fontSize: FONT_SIZE_REM[style.font_size] }
      : {}),
    ...(style?.text_align ? { textAlign: style.text_align } : {}),
  };
}
